import firebase from 'firebase/app';

// databaseURLやstrageBucketなどは使わないが含めておく
export const firebaseConfig = {
  apiKey: 'AIzaSyAqv1wamLpEoRk96FjA-XLw011SgmLx-tM',
  authDomain: 'dadc-d1137.firebaseapp.com',
  databaseURL: 'https://dadc-d1137-default-rtdb.firebaseio.com',
  projectId: 'dadc-d1137',
  storageBucket: 'dadc-d1137.appspot.com',
  messagingSenderId: '434185803956',
  appId: '1:434185803956:web:bbc71152294d13ca2fdfe1',
};
